import { render } from "./receiptView.vue?vue&type=template&id=1950820f&scoped=true"
import script from "./receiptView.vue?vue&type=script&lang=js"
export * from "./receiptView.vue?vue&type=script&lang=js"

import "./receiptView.vue?vue&type=style&index=0&id=1950820f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1950820f"]])

export default __exports__